var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('w-btn',{attrs:{"color":"purple","loading":_vm.loading,"text":_vm.$t('common.unarchive'),"icon":"mdi-archive"},on:{"press":_setup.press}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }